import { IAppliedDoc } from 'pages/application/applicationDocument/acknowledgmentDenialDismissal/type';
import { ReApplyDetailsType } from 'pages/application/reApply/type';
import * as reApplyDocument from './actions';
import reducer from './reducer';

export type InitialReApplyDocument = ReApplyDetailsType | IAppliedDoc;

export {
  reApplyDocument,
};

export default reducer;
